module.exports = __webpack_public_path__ + "static/media/totally_wowed.21c66b6b.svg";